import Repository from './Repository';
const resource = '/content/top/notice';

export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
